import React from 'react';
import { ReactComponent as ApiManagementServicesIcon } from './api_management_services.svg';

export default props => {
    const { className, style } = props;
    return <ApiManagementServicesIcon className={className} style={style} aria-label='Api Management Services Icon' />
}